import {
  Skeleton,
  SkeletonButton,
  SkeletonCard,
  SkeletonText,
  SkeletonTitle,
} from './SkeletonComponents';

export function ExpenseEditSkeleton() {
  return (
    <div className="max-w-2xl mx-auto">
      {/* Header - matching actual layout */}
      <div className="flex items-center mb-8">
        <div className="mr-4 p-2 rounded-lg hover:bg-[#FAF9F7] dark:hover:bg-gray-800/50 transition-colors">
          <Skeleton className="w-5 h-5" />
        </div>
        <div>
          <SkeletonTitle className="w-32 mb-2" />
          <div className="flex items-center gap-1">
            <SkeletonText className="w-28 bg-orange-200" />
          </div>
        </div>
      </div>

      {/* Form - matching actual ExpenseForm structure exactly */}
      <div className="space-y-6">
        {/* ExpenseBasicInfo Card - exactly like ExpenseCreateSkeleton */}
        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-xs p-6">
          <div className="space-y-4">
            {/* Amount and Title - matching actual grid layout */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {/* Amount field */}
              <div>
                <Skeleton className="w-20 h-4 mb-1" />
                <Skeleton className="w-full h-12 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700" />
              </div>

              {/* Title field - spans 2 columns */}
              <div className="sm:col-span-2">
                <Skeleton className="w-32 h-4 mb-1" />
                <Skeleton className="w-full h-12 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700" />
              </div>
            </div>

            {/* Category Selection - shows as filled in edit mode */}
            <div>
              <Skeleton className="w-20 h-4 mb-2" />
              <div className="flex gap-2">
                <Skeleton className="w-24 h-10 rounded-lg bg-gray-100 dark:bg-gray-800" />
                <Skeleton className="w-32 h-10 rounded-lg bg-gray-100 dark:bg-gray-800" />
              </div>
              <SkeletonText className="w-64 mt-2 text-xs" />
            </div>
          </div>
        </div>

        {/* SplitRecap Card - visible in edit mode since categoryPredicted would be true */}
        <SkeletonCard className="p-4 cursor-pointer">
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <SkeletonText className="w-16" />
                <SkeletonText className="w-20 font-bold" />
              </div>
              <Skeleton className="w-5 h-5" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="w-4 h-4" />
              <SkeletonText className="w-48 text-sm" />
            </div>
            <div className="flex items-center gap-2">
              <SkeletonText className="w-24 text-sm" />
              <SkeletonText className="w-20" />
            </div>
            <SkeletonText className="w-40 text-sm" />
            <SkeletonText className="w-36 text-xs" />
          </div>
        </SkeletonCard>

        {/* Progressive Disclosure Toggle */}
        <div className="flex justify-center">
          <SkeletonButton className="w-48" />
        </div>

        {/* Form Actions - matching actual layout with "Save" button */}
        <div className="flex justify-end space-x-3 pt-6">
          <SkeletonButton className="w-20" />
          <SkeletonButton className="w-16 bg-orange-500 dark:bg-orange-600" />
        </div>
      </div>
    </div>
  );
}
